import palette from '../theme/palette';

const variants = [
  {
    props: { color: 'internal' },
    style: {
      '& .MuiSwitch-track': {
        backgroundColor: palette.internal.main,
      },
      '& .MuiSwitch-thumb': {
      },
    },
  },
];

export default variants;
